var BraintreeToken = (function (Backbone) {

	var BraintreeToken = Backbone.Model.extend({

		initialize: function (attrs, opts) {
			this._token = opts.api.getPaymentToken({ hideErrors: true });
		},

		done: function (cb) {
			this._token.done(function (data) {
				cb(data.Value.Token);
			});
		},

		error: function (cb) {
			this._token.fail(function (data) {
				cb(data);
			});
		}
	});

	return BraintreeToken;
})(Backbone);